import { AuthService } from './auth.service';

export const AUTH_DEBUG_HANDLE = '__auth';

export function exposeAuthDebugHandle(
  authService: AuthService,
  debug: boolean
): void {
  if (!debug) {
    return;
  }

  Reflect.set(globalThis, AUTH_DEBUG_HANDLE, {
    token: (): string | null => authService.getAccessToken(),
    valid: (): boolean => authService.hasValidToken(),
    refresh: async (): Promise<{ token: string | null }> => {
      await authService.refresh();
      return { token: authService.getAccessToken() };
    },
  });
}
